import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import {
  ADD_SUGGESTION,
  ADD_WORD,
  REMOVE_WORD, SET_DOMAIN_CHECKS, SET_DOUBLEMEANING_CHECK,
  SET_GENERATED_WORDS,
  SET_RANDOMNESS, SET_RECOMMENDED_WORDS,
  SET_WORDS,
  SET_WORDS_LENGTH, TOGGLE_DOMAIN_AVAILABILITY_FILTER
} from './mutation-types';
import {GET_DOMAIN_CHECKS, GET_DOUBLEMEANING_CHECK, GET_RECOMMENDATIONS, SEND_WORDS} from './action-types';
import {TOGGLE_DICTIONARY_MODE, SET_DOMAINS_LOADING, SET_RECOMMENDATIONS_LOADING} from '@/store/mutation-types';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    words: [],
    randomness: 4,
    wordsLength: 8,
    generatedWords: [],
    recommendedWords: [],
    domainChecks: [],
    doubleMeaningChecks: {}, // {string:boolean}
    loadingStates: {
      recommendations: false,
      domains: false
    },
    dictionaryMode: false,
    domainAvailabilityFilters: [],
  },
  mutations: {
    [SET_WORDS] (state, payload) {
      state.words = payload.words;
    },
    [ADD_WORD] (state, payload) {
      state.words.push(payload.word);
    },
    [ADD_SUGGESTION] (state, payload) {
      state.words.push(payload.word);
    },
    [REMOVE_WORD] (state, payload) {
      state.words = state.words.filter(word => word.uuid !== payload.uuid);
    },
    [SET_RANDOMNESS] (state, payload) {
      state.randomness = payload.value;
    },
    [SET_WORDS_LENGTH] (state, payload) {
      state.wordsLength = payload.value;
    },
    [SET_GENERATED_WORDS] (state, payload) {
      if (payload.replaceLoad) {
          state.generatedWords = payload.generatedWords;
          return;
      }
      state.generatedWords = [...state.generatedWords, ...payload.generatedWords];
    },
    [SET_RECOMMENDED_WORDS] (state, payload) {
      state.recommendedWords = payload.recommendedWords;
    },
    [SET_DOMAIN_CHECKS] (state, payload) {
      if (payload.replaceLoad) {
          state.domainChecks = payload.domainChecks;
          return;
      }
      state.domainChecks = [...state.domainChecks, ...payload.domainChecks];
    },
    [SET_DOUBLEMEANING_CHECK] (state, payload) {
      Vue.set(state.doubleMeaningChecks, payload.name, payload.hasDoubleMeaning);
    },
    [SET_RECOMMENDATIONS_LOADING] (state, payload) {
      state.loadingStates.recommendations = payload.loading;
    },
    [SET_DOMAINS_LOADING] (state, payload) {
      state.loadingStates.domains = payload.loading;
    },
    [TOGGLE_DICTIONARY_MODE] (state) {
      state.dictionaryMode = !state.dictionaryMode;
    },
    [TOGGLE_DOMAIN_AVAILABILITY_FILTER] (state, payload) {
      if (state.domainAvailabilityFilters.includes(payload.extension)) {
        state.domainAvailabilityFilters.splice(state.domainAvailabilityFilters.indexOf(payload.extension), 1);

        return;
      }

      state.domainAvailabilityFilters.push(payload.extension);
    }
  },
  actions: {
    [SEND_WORDS] (context, replace = false) {
      context.commit(SET_DOMAINS_LOADING, {loading: true});

      let randomness = context.state.randomness;
      randomness = randomness < 1 ? 0 : (randomness > 10 ? 10 : randomness)
      randomness = randomness/10
      axios
          .post(`.netlify/functions/recommendations`,{
            words: context.state.words.map(word => word.word.toLowerCase().trim()),
            randomness: randomness,
          })
          .then(response => {
            /**
             * cut long words in case the model went crazy. also useless for domains
             * cut at 15 because we can check up to 3 TLDs at the same time and are limited to 50 checks
             * at once by namecheap's api
            **/
            const recommendations = response.data.recommendations.filter(word => word.length < 20).slice(0,15);
            context.commit(SET_DOMAINS_LOADING, {loading: false});
            context.commit(SET_GENERATED_WORDS, {generatedWords: recommendations, replaceLoad: replace});

            this.dispatch(GET_DOMAIN_CHECKS, {words: recommendations, replaceLoad: replace});
          });
    },
    [GET_RECOMMENDATIONS] (context, word) {
      context.commit(SET_RECOMMENDATIONS_LOADING, {loading: true});
      axios
          .get(`.netlify/functions/related`,{
            params: {
              word: word
            }
          })
          .then(response => {
            context.commit(SET_RECOMMENDATIONS_LOADING, {loading: false});
            context.commit(SET_RECOMMENDED_WORDS, {recommendedWords: response.data.suggestions});
          });
    },
    [GET_DOMAIN_CHECKS] (context, payload) {
      context.commit(SET_DOMAINS_LOADING, {loading: true});
      axios
          .post(`${process.env.VUE_APP_BACKEND_URL}/check/domain`,{
              names: payload.words,
              tlds: ['com', 'co', 'io'],
              availabilityFilters: context.state.domainAvailabilityFilters,
          })
          .then(response => {
            context.commit(SET_DOMAINS_LOADING, {loading: false});
            context.commit(SET_DOMAIN_CHECKS, {domainChecks: response.data.checks, replaceLoad: payload.replaceLoad});
          });
    },
    [GET_DOUBLEMEANING_CHECK] (context, word) {
      axios
          .post(`${process.env.VUE_APP_BACKEND_URL}/check/doublemeaning`,{
              name: word,
          })
          .then(response => {
            context.commit(SET_DOUBLEMEANING_CHECK, {name: response.data.name, hasDoubleMeaning: response.data.hasDoubleMeaning});
          });
    },
  },
  modules: {
  }
})
